const _isLengthCBU = function(cbu) {
  return cbu && cbu.length == 22
}

const _isValidAccount = function(acc) {
  if (!acc || acc.length !== 14) {
    return false
  }

  let sum =
    acc[0] * 3 +
    acc[1] * 9 +
    acc[2] * 7 +
    acc[3] * 1 +
    acc[4] * 3 +
    acc[5] * 9 +
    acc[6] * 7 +
    acc[7] * 1 +
    acc[8] * 3 +
    acc[9] * 9 +
    acc[10] * 7 +
    acc[11] * 1 +
    acc[12] * 3
  let diff = (10 - (sum % 10)) % 10 // the result of this should be only 1 digit
  let checksum = acc[13]

  return diff == checksum
}

const _isValidBankCode = function(code) {
  if (!code || code.length !== 8) {
    return false
  }
  let bank = code.substr(0, 3)
  let checksumOne = code[3]
  let branch = code.substr(4, 3)
  let checksumTwo = code[7]

  let sum =
    bank[0] * 7 +
    bank[1] * 1 +
    bank[2] * 3 +
    checksumOne * 9 +
    branch[0] * 7 +
    branch[1] * 1 +
    branch[2] * 3
  let diff = (10 - (sum % 10)) % 10 // the result of this should be only 1 digit

  return diff == checksumTwo
}

const isValidCBU = function(cbu) {
  if (!cbu || !cbu.substr) return false
  let bankCode = cbu.substr(0, 8)
  let accountCode = cbu.substr(8, 14)
  return (
    _isLengthCBU(cbu) &&
    _isValidBankCode(bankCode) &&
    _isValidAccount(accountCode)
  )
}

export {  isValidCBU, _isLengthCBU }
